import classNames from 'classnames';
import { ProjectWizardContext } from 'context/Context';
import { Field, Form, Formik } from 'formik';
import lodash from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Col, Collapse, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FiInfo, FiMapPin } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { LocationSchema } from '../../validations/projectsValidation';
import InputAddressAutocomplete from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/utils/InputAutocomplete';
import GoogleMap from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/utils/GoogleMap';
import messageHandler from 'utils/messageHandler';
import Select from 'react-select';

const Ubicacion = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef } =
    useContext(ProjectWizardContext);

  const { neighborhoods, neighborhoodsObj } = useSelector(state => state.props);

  const [currentNeighborhood, setCurrentNeighborhood] = useState({});
  const [mobileGoogle, setMobileGoogle] = useState(false); // para hacer mobile el googlemaps
  const [ready, setReady] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const initialValues = {
    street: data.location?.street || '',
    number: data.location?.number || '',
    barrios: data.location?.barrios || '',
    lat: data.location?.lat || '',
    lng: data.location?.lng || '',
    cp: data.location?.cp || '',
    cp_suffix: data.location?.cp_suffix || '',
    area_level_1: data.location?.area_level_1 || '',
    area_level_2: data.location?.area_level_2 || '',
    locality: data.location?.locality || ''
  };

  const neighborhoodOptions = [
    { value: 0, label: '-- Selecciona el barrio --' },
    ...neighborhoods.map(({ value, label }) => ({
      value,
      label
    }))
  ];

  const currentNeighborhoodOptions = [
    { value: 0, label: '-- Selecciona el barrio coloquial --' },
    ...(currentNeighborhood?.children || []).map(({ value, label }) => ({
      value,
      label
    }))
  ];

  return (
    <>
      {data && (
        <>
          <h4 className="my-4">
            <FiMapPin /> Agregue la Ubicación
            <OverlayTrigger
              overlay={
                <Tooltip id={`tooltip-top`} className="small">
                  Recuerde que el emprendimiento debe estar ubicado en CABA.
                </Tooltip>
              }
            >
              <span>
                <FiInfo className="ms-2" size={16} />
              </span>
            </OverlayTrigger>
          </h4>
          <Formik
            initialValues={initialValues}
            validationSchema={LocationSchema}
            onSubmit={values =>
              handleSubmit(
                {
                  location: { ...values }
                },
                lodash.isEqual(values, initialValues)
              )
            }
          >
            {({ errors, setValues, values }) => {
              useEffect(() => {
                setStepStatus(prev => ({
                  ...prev,
                  location: { ...values }
                }));

                if (values.barrios && values.barrios[0]) {
                  setCurrentNeighborhood(
                    neighborhoods.find(n => n.value === values.barrios[0])
                  );
                } else {
                  setCurrentNeighborhood({});
                }
              }, [values, neighborhoods]);

              return (
                <Form
                  className="contact_form profile mb30"
                  onKeyDown={e => {
                    e.key === 'Enter' && e.preventDefault();
                  }}
                >
                  <Row>
                    <Col xs={12} sm={12} md={5}>
                      <Row className="g-3">
                        <Col xs={12}>
                          <label className="mb-2 w-100">
                            Ingrese la dirección del inmueble{' '}
                            <span className="text-danger">*</span>
                          </label>

                          <InputAddressAutocomplete
                            setMobileGoogle={setMobileGoogle}
                            ready={ready}
                            values={values}
                            setValues={setValues}
                            emptyInput={emptyInput}
                            setEmptyInput={setEmptyInput}
                            name="autocomplete"
                            neighborhoods={neighborhoods}
                          />

                          {errors.street &&
                            errors.number &&
                            (emptyInput ? (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                El campo "dirección" es requerido.
                              </label>
                            ) : (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                La dirección ingresada no corresponde a un
                                domicilio en CABA.
                              </label>
                            ))}

                          {(!errors.street || !errors.number) &&
                            errors.barrios && (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                No hemos podido detectar el barrio. Seleccione
                                uno manualmente para poder continuar.
                              </label>
                            )}
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !values.lat
                          })}
                        >
                          <Collapse in={!!values.lat}>
                            <div>
                              <label className="mb-2 w-100">
                                Seleccione el barrio al que pertenece{' '}
                                <span className="text-danger">*</span>
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-top`}
                                      className="small"
                                    >
                                      El sistema te recomendará el barrio al que
                                      pertenece la dirección ingresada. Pero
                                      podés modifcarlo si lo considerás
                                      necesario.
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <FiInfo className="ms-2" size={16} />
                                  </span>
                                </OverlayTrigger>
                              </label>

                              <Select
                                name="barrios"
                                value={
                                  values.barrios?.length
                                    ? neighborhoodOptions.find(
                                        option =>
                                          option.value === values.barrios[0]
                                      )
                                    : neighborhoodOptions[0]
                                }
                                onChange={selectedOption => {
                                  setValues({
                                    ...values,
                                    barrios: selectedOption.value
                                      ? [selectedOption.value]
                                      : []
                                  });
                                }}
                                options={neighborhoodOptions}
                                isSearchable={false}
                              />
                            </div>
                          </Collapse>
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !currentNeighborhood?.children
                          })}
                        >
                          <Collapse in={!!currentNeighborhood?.children}>
                            <div>
                              <label className="mb-2 w-100">
                                Seleccione el barrio coloquial
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-top`}
                                      className="small"
                                    >
                                      El sistema le recomendará el barrio al que
                                      pertenece la dirección ingresada, pero
                                      puede modifcarlo si lo considera
                                      necesario.
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <FiInfo className="ms-2" size={16} />
                                  </span>
                                </OverlayTrigger>
                              </label>

                              <Select
                                name="barrios"
                                value={
                                  values.barrios
                                    ? neighborhoodOptions.find(
                                        option =>
                                          option.value === values.barrios[1]
                                      )
                                    : neighborhoodOptions[0]
                                }
                                onChange={selectedOption => {
                                  setValues(prev => ({
                                    ...prev,
                                    barrios: selectedOption.value
                                      ? [
                                          prev.barrios[0],
                                          Number(selectedOption.value)
                                        ]
                                      : [prev.barrios[0]]
                                  }));
                                }}
                                options={currentNeighborhoodOptions}
                                isSearchable={false}
                              />
                            </div>
                          </Collapse>
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !values?.street
                          })}
                        >
                          <Collapse in={!!values?.street}>
                            <div>
                              <h5 className="border-bottom pb-2">
                                Domicilio Registrado
                              </h5>
                              <ul className="list-unstyled mb-0">
                                <li>
                                  <strong>Calle:</strong> {values.street}
                                </li>
                                <li>
                                  <strong>Altura:</strong> {values.number}
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-top`}
                                        className="small"
                                      >
                                        La propiedad se mostrará {values.street}{' '}
                                        {Math.floor(values.number / 10) * 10}
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <FiInfo className="ms-2" size={14} />
                                    </span>
                                  </OverlayTrigger>
                                </li>

                                <li>
                                  <strong>Barrio:</strong>{' '}
                                  {neighborhoodsObj[values.barrios?.at(-1)] ||
                                    '-'}
                                </li>
                              </ul>
                            </div>
                          </Collapse>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      className={`google-map ${
                        mobileGoogle ? 'mobileGoogle' : ''
                      } position-relative pt-1`}
                      xs={12}
                      sm={12}
                      md={7}
                    >
                      <GoogleMap
                        className="border"
                        values={values}
                        setValues={setValues}
                        mapStyle=""
                        darkStyle=""
                        zoom={values.lat ? 17 : 11}
                        onReady={() => setReady(true)}
                        center={
                          values.lat && values.lng
                            ? { lat: values.lat, lng: values.lng }
                            : { lat: -34.6106694, lng: -58.4300401 }
                        }
                      />
                    </Col>
                  </Row>

                  <Field
                    type="hidden"
                    name="street"
                    className="form-control-sm w-100"
                    disabled
                  />

                  <Field
                    type="hidden"
                    className="form-control-sm w-100"
                    name="number"
                    disabled
                  />
                  <button
                    onClick={() =>
                      Object.keys(errors).length &&
                      messageHandler(
                        'error',
                        'Uno o más campos son incorrectos. Por favor, corrija los errores para poder continuar.'
                      )
                    }
                    hidden
                    ref={yupSubmitRef}
                  ></button>
                </Form>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};

export default Ubicacion;
